import { Brand } from '../../common/types';
import apiClient from '../apiClient';

interface SuggestedBrandsRequest {
    partner_id: string;
}
interface SuggestedBrandsResponse {
    brands: Record<string, any>[];
}

export const getSuggestedBrands = async (partnerId: string): Promise<Brand[] | undefined> => {
    try {
        console.debug(`Fetching suggested brands for partner_id: ${partnerId}...`);

        const requestBody: SuggestedBrandsRequest = { partner_id: partnerId };

        const response: SuggestedBrandsResponse = await apiClient('/widget/suggested_brands', {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.brands || !Array.isArray(response.brands)) {
            throw new Error(`Failed to fetch suggested brands for partner_id: ${partnerId}`);
        }

        console.debug(`[SUCCESS] Fetched suggested brands for partner_id: ${partnerId}`, response);

        // Parse response to array of Brand objects
        return response.brands.map((b) => ({
            code: b.brand_code,
            name: b.brand_label,
            image: b.image,
            label: b.brand_label,
            domain: b.domain,
            faviconUrl: b.favicon_url,
        })) as Brand[];
    } catch (error) {
        console.error('Failed to fetch suggested brands', error);
    }
};
